export const showAddVehiclesModal = () => {
    return {
      type: "SHOW_ADD_VEHICLES_MODAL",
    };
  };
  
  export const hideAddVehiclesModal = () => {
    return {
      type: "HIDE_ADD_VEHICLES_MODAL",
    };
  };
  